import React from 'react'

export default function Progresbar({ title, value, setIsModalOpen }) {
    return (
        <div
            onClick={() => setIsModalOpen(true)}
            className="pb-4 col-span-2 cursor-pointer p-2 -m-2 rounded-lg transition duration-200 mt-2"
        >
            <div className="flex justify-between items-center mb-2">
                <h3 className="text-xl font-bold flex items-center">
                    {/* Use one of the new primary colors for consistency */}
                    <span className="tracking-wider text-black">{title}</span>
                </h3>
                <span className="text-xl font-extrabold text-green">
                    {value}%
                </span>
            </div>

            {/* Progress Bar Container */}
            <div className="w-full rounded-full h-3.5 overflow-hidden bg-gray">
                <div
                    className={
                        'h-full rounded-full transition-all duration-1000 ease-out bg-green'
                    }
                    style={{ width: `${value}%` }}
                ></div>
            </div>
        </div>
    )
}
